import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import striptags from 'striptags'
import { setUserMenuVisible } from 'tennders-common/stores/view/action'
import { GButton, GInput } from 'tennders-common/form/components'
import useCompanyDirectoryCompanies from 'tennders-company/list/hooks/useCompanyDirectoryCompanies'
import useFetchOptions from 'tennders-common/hooks/useFetchOptions'
import useSession from 'tennders-auth/hooks/useSession'
import GDatePicker from 'tennders-common/form/components/date'
import GHref from 'tennders-market/common/components/element/GHref'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import PasswordChange from './PasswordChange'
import PaymentTerms from './PaymentTerms'
import NotifSettings from './NotifSettings'

const UserMenu = () => {
  const { t } = useTranslation()
  const { saveCompany } = useCompanyDirectoryCompanies()
  const [editmode, seteditmode] = useState(false)
  const [form, setform] = useState({})
  const [errors, seterrors] = useState({})
  const dispatch = useDispatch()
  const userMenu = useSelector((state) => state.view.isUserMenuVisible)
  const [saving, setsaving] = useState(false)
  const [isListenerMounted, setIsListenerMounted] = useState(false)
  const { options } = useFetchOptions('cmrTypes,paymentTermTypes,notifTypes')
  const closeUserMenu = () => dispatch(setUserMenuVisible(false))
  const { user, logout, fetchUser, isCarrierUser, isShipperUser } = useSession()

  const onChange = (k, v) => {
    setform({ ...form, [k]: v })
  }

  const save = async () => {
    setsaving(true)
    const response = await saveCompany(user.company.id, form)
    if (response.errors) {
      seterrors(response.errors)
    }
    // else seteditmode(false);
    setsaving(false)
  }

  const commonProps = {
    form,
    onChange,
    errors
  }

  const handleLogout = () => {
    closeUserMenu()
    logout()
  }

  const escFunction = (event) => {
    if (event.key === 'Escape') {
      closeUserMenu()
    }
  }

  useEffect(() => {
    fetchUser()
  }, [])

  useEffect(() => {
    if (!isListenerMounted && userMenu) {
      setIsListenerMounted(true)
      document.removeEventListener('keydown', escFunction)
      document.addEventListener('keydown', escFunction, false)
    }
    return () => {
      document.removeEventListener('keydown', escFunction)
      setIsListenerMounted(false)
    }
  }, [userMenu])

  useEffect(() => {
    if (user) {
      const comp = { ...user.company }
      if (comp.address) {
        comp.address = striptags(comp.address).replace(/&nbsp;/g, '')
      }
      delete comp.paymentTerms
      setform({ ...comp })
    }
  }, [user && user.unreadNotifCount])

  return (
    <>
      <div className={'tennders-overlay' + (userMenu ? ' show' : '')} />
      <div className={`tennders-user-menu-right tennders-custom-scroll${userMenu ? ' show' : ''}`}>
        <GHref
          onClick={closeUserMenu}
          className={`tennders-user-menu-right-close${userMenu ? ' show' : ''}`}
        >
          <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
        </GHref>
        <div className="tennders-user-menu-right-section">
          <div className="d-flex row justify-space">
            <h4 className="bold">{`${user?.name} (${user?.email})`}</h4>
            <div className="text-right">
              <div className="text-12 italic color-p">
                {user?.title}
                {' '}
                for
              </div>
              <div>{user?.company && user?.company?.name}</div>
            </div>
          </div>
          {process?.env?.NEXT_PUBLIC_OLD_UI_URL && <GHref className="text-underline btn-link" href={process.env.NEXT_PUBLIC_OLD_UI_URL}>{t('menus:use_old_ui')}</GHref>}
        </div>
        <div className="hr" />
        {user?.company && (
          <div className="tennders-user-menu-right-section">
            <div className="d-flex row justify-space align-center mb-20">
              <h3 className="bold mb-0 text-underline">{t('menus:companyDetails')}</h3>
            </div>
            <div>
              {editmode ? <GInput name="name" {...commonProps} /> : form.name}
              {' '}
              <br />
              <br />
              {editmode ? (
                <GInput
                  type="textarea"
                  name="address"
                  {...commonProps}
                />
              ) : form.address}
            </div>
            <div className="text-13">
              <b>
                {t('menus:nif')}
                {' '}
                :
              </b>
              {' '}
              {editmode ? (
                <GInput
                  name="nif"
                  {...commonProps}
                  maxLength={INPUT_CHARACTER_LIMITS.VAT_ID}
                />
              ) : form.nif}
              {' '}
              {!isCarrierUser && !isShipperUser && (
                <>
                  <br />
                  <br />
                  <b>
                    {t('menus:euRegNumber')}
                    {' '}
                    :
                  </b>
                  {' '}
                  {editmode ? (
                    <GInput
                      name="registrationNumber"
                      {...commonProps}
                    />
                  ) : form.registrationNumber}
                  {' '}
                  <br />
                  <br />
                  <b>
                    {t('menus:companyInsurance')}
                    {' '}
                    :
                  </b>
                  {' '}
                  {editmode
                    ? (
                      <>
                        <GInput name="companyInsuranceProvider" {...commonProps} />
                        <br />
                        <b>
                          {t('menus:companyInsuranceExpires')}
                          {' '}
                          :
                        </b>
                        <GDatePicker
                          single
                          type="date"
                          name="insuranceExpiresAt"
                          {...commonProps}
                        />
                      </>
                    ) : (
                      <>
                        {form.companyInsuranceProvider}
                      </>
                    )}
                  <br />
                  <br />
                  <b>
                    {t('menus:liabilityInsuranceLimit')}
                    {' '}
                    :
                  </b>
                  {' '}
                  {editmode
                    ? (
                      <>
                        <GInput
                          currency="€"
                          type="currency"
                          {...commonProps}
                          name="liabilityInsurance"
                          {...commonProps}
                        />
                        <br />
                        <b>
                          {t('menus:liabilityInsuranceExpires')}
                          {' '}
                          :
                        </b>
                        <GDatePicker
                          single
                          type="date"
                          name="liabilityInsuranceExpiresAt"
                          {...commonProps}
                        />
                      </>
                    ) : (
                      <>
                        <GCurrency value={form.liabilityInsurance} />
                        {(` (exp : ${(form.liabilityInsuranceExpiresAt && (new Date(form.liabilityInsuranceExpiresAt)).toLocaleDateString('es-ES')) || '-'})`)}
                      </>
                    )}
                </>
              )}
              {editmode && (
                <div className="row d-flex">
                  <GButton
                    onClick={() => seteditmode(false)}
                    className="btn-border standard-btn d-block text-center mr-8"
                    labelKey="menus:cancel"
                  />
                  <GButton
                    onClick={save}
                    submitting={saving}
                    className="btn standard-btn bold tennders-add-load-buy-btn cursor-pointer"
                    labelKey="menus:save"
                  />
                </div>
              )}
              <div className="hr" />
              <PaymentTerms />
            </div>
          </div>
        )}
        {!isShipperUser && !isCarrierUser && (
          <>
            <div className="hr" />
            <NotifSettings notifTypes={options?.notifTypes} />
          </>
        )}
        <div className="hr" />
        <PasswordChange />
        <div className="hr" />
        <GHref
          onClick={handleLogout}
          className="btn-border standard-btn d-flex justify-center text-center"
        >
          {t('auth:logout')}
        </GHref>
      </div>
    </>
  )
}

export default UserMenu
